/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Input, InputNumber, Modal, Select, Spin, message } from 'antd'

import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { monthsMap } from 'core'
import JcTmpErrorDialog, {
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { solarStoragePerformanceSave } from './solarapi'
import {
  SHOW_SOLAR_STORAGE_DATA,
  SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
  SOLAR_ADMIN_POWER_DATA,
} from '../core/EventActions'
import { connect } from 'react-redux'
import { getPermitActions } from '../core/selectors'
import { hasAccesPermits } from 'core/utils'

const SolarStoragePerformanceDialog = ({
  data,
  targetInfo,
  visible,
  onHide = _ => _,
  onRetrieve,
  isNew = false,
  avalibilityStatusIdMap,
  availableStatus,
  actionPermits,
  isStorageDialog = false,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [insertData, setInsertData] = useState(data)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [
          SOLAR_ADMIN_POWER_DATA,
          SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const onSave = _ => {
    setSpinning(true)
    solarStoragePerformanceSave(targetInfo)([insertData]).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          onHide()
          onRetrieve()
        }
      }
    )
  }

  return (
    <Modal
      onCancel={onHide}
      visible={visible}
      footer={
        <div>
          <div>
            {hasSolarPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      centered
      height={400}
      width={1200}
      title={<div>Storage Performance Data : {insertData.subgroupName}</div>}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '230px  150px 120px 100px 100px 100px',
            gap: 5,
            width: 1000,
          }}
        >
          {isStorageDialog && [
            <Label key="gp">Storage :</Label>,
            <Input
              key="gp2"
              css={{ gridColumnEnd: 'span 5' }}
              value={insertData.storageGroupId}
              disabled
            />,
          ]}
          <Label>Availability Status :</Label>
          <Select
            style={{ gridColumnEnd: 'span 3' }}
            value={insertData.storageGroupAvailability}
            onChange={storageGroupAvailability =>
              setInsertData({ ...insertData, storageGroupAvailability })
            }
          >
            {availableStatus.map(
              ({ availabilityStatusCode, availabilityStatusName }) => (
                <Select.Option
                  value={availabilityStatusCode}
                  key={availabilityStatusCode}
                >
                  {availabilityStatusName}
                </Select.Option>
              )
            )}
          </Select>
          <div style={{ gridColumnEnd: 'span 2' }} />

          <Label>Charge MWh :</Label>
          <InputNumber
            value={insertData.chargeMwh}
            onChange={chargeMwh => setInsertData({ ...insertData, chargeMwh })}
          />

          <Label>Discharge MWh :</Label>
          <InputNumber
            value={insertData.dischargeMwh}
            onChange={dischargeMwh =>
              setInsertData({ ...insertData, dischargeMwh })
            }
          />

          <Label>FO Hrs :</Label>
          <InputNumber
            value={insertData.foHrs}
            onChange={foHrs => setInsertData({ ...insertData, foHrs })}
          />

          <Label>Charge Hrs :</Label>
          <InputNumber
            value={insertData.chargeHrs}
            onChange={chargeHrs => setInsertData({ ...insertData, chargeHrs })}
          />

          <Label>Discharge Hrs :</Label>
          <InputNumber
            value={insertData.dischargeHrs}
            onChange={dischargeHrs =>
              setInsertData({ ...insertData, dischargeHrs })
            }
          />

          <Label>MO Hrs :</Label>
          <InputNumber
            value={insertData.moHrs}
            onChange={moHrs => setInsertData({ ...insertData, moHrs })}
          />

          <div style={{ gridColumnEnd: 'span 4' }} />
          <Label>PO Hrs :</Label>
          <InputNumber
            value={insertData.poHrs}
            onChange={poHrs => setInsertData({ ...insertData, poHrs })}
          />
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({ actionPermits: getPermitActions(state) })

export default connect(mapStateToProps)(SolarStoragePerformanceDialog)
